<form novalidate #currentForm="ngForm">
  <div class="form-group">
    <label>Type</label>
    <br />
    <div class="custom-control custom-radio custom-control-inline" (click)="contact.type = 'Company'">
      <input [checked]="contact.type == 'Company'" type="checkbox" name="type" class="custom-control-input" />
      <label class="custom-control-label">Company</label>
    </div>
    &nbsp;&nbsp;
    <div class="custom-control custom-radio custom-control-inline" (click)="contact.type = 'Person'">
      <input [checked]="contact.type == 'Person'" type="checkbox" name="type" class="custom-control-input" />
      <label class="custom-control-label">Person</label>
    </div>
    <div class="invalid-feedback d-block" *ngIf="!contact.type && formSubmitted">Type must be selected</div>
  </div>
  <div class="form-group">
    <label>Display Name</label>
    <input type="text" class="form-control form-control-sm" name="display_name" [(ngModel)]="contact.display_name" required/>
    <div class="invalid-feedback d-block" *ngIf="!contact.display_name && formSubmitted">Display Name is required</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Company'">
    <label>Company Name</label>
    <input class="form-control form-control-sm" type="text" name="company_name" [(ngModel)]="contact.company_name" required />
    <div class="invalid-feedback d-block" *ngIf="!contact.company_name && formSubmitted">Company Name is required</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Company'">
    <label>Company Suffix</label>
    <input type="text" class="form-control form-control-sm" name="company_suffix" [(ngModel)]="contact.company_suffix" />
  </div>
  <div class="form-group" *ngIf="contact.type == 'Company'">
    <label>EIN</label>
    <input type="text" class="form-control form-control-sm" name="ein" [(ngModel)]="contact.ein" />
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Qualifier</label>
    <select name="qualifier_id" class="form-control form-control-sm" [(ngModel)]="contact.qualifier_id">
      <option *ngFor="let qualifier of formOptions.qualifiers" [value]="qualifier.value">
        {{ qualifier.label }}
      </option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="contact.honorarium_id && contact.qualifier_id && formSubmitted">Qualifier and Honorarium cannot be used together</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>First Name</label>
    <input class="form-control form-control-sm" type="text" name="first_name" [(ngModel)]="contact.first_name" required />
    <div class="invalid-feedback d-block" *ngIf="!contact.first_name && formSubmitted">First Name is required</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Middle Initial</label>
    <input type="text" class="form-control form-control-sm" name="middle_name" [(ngModel)]="contact.middle_name" />
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Last Name</label>
    <input class="form-control form-control-sm" type="text" name="last_name" [(ngModel)]="contact.last_name" required />
    <div class="invalid-feedback d-block" *ngIf="!contact.last_name && formSubmitted">Last Name is required</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Gender</label>
    <select name="gender" required class="form-control form-control-sm" [(ngModel)]="contact.gender">
      <option *ngFor="let gender of formOptions.genders" [value]="gender.value">
        {{ gender.label }}
      </option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="!contact.gender && formSubmitted">Gender is required</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Generational Qualifier</label>
    <select name="generational_qualifier_id" class="form-control form-control-sm" [(ngModel)]="contact.generational_qualifier_id">
      <option *ngFor="let generational_qualifier of formOptions.generational_qualifiers" [value]="generational_qualifier.value">
        {{ generational_qualifier.label }}
      </option>
    </select>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Honorarium</label>
    <select name="honorarium_id" class="form-control form-control-sm" [(ngModel)]="contact.honorarium_id">
      <option *ngFor="let honorarium of formOptions.honoraria" [value]="honorarium.value">
        {{ honorarium.label }}
      </option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="contact.honorarium_id && contact.qualifier_id && formSubmitted">Qualifier and Honorarium cannot be used together</div>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Birth Date</label>
    <app-datetime-picker [datetime]="contact.dob_struct" [showTimePicker]="false" [small]="true" (ngbResult)="contact.dob_struct = $event"></app-datetime-picker>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Date of Death</label>
    <app-datetime-picker [datetime]="contact.dod_struct" [showTimePicker]="false" [small]="true" (ngbResult)="contact.dod_struct = $event"></app-datetime-picker>
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Social Security Number</label>
    <input type="text" class="form-control form-control-sm" name="ssn" [(ngModel)]="contact.ssn" />
  </div>
  <div class="form-group" *ngIf="contact.type == 'Person'">
    <label>Employer</label>
    <app-contact-search [contactId]="contact.employer_id" (clearContact)="contact.employer_id = null" (contact_id)="contact.employer_id = $event"></app-contact-search>
  </div>
  <div class="form-group">
    <label>Owned By</label>
    <select name="owned_by" class="form-control form-control-sm" [(ngModel)]="contact.owned_by">
      <option *ngFor="let attorney of formOptions.attorneys_for_select" [value]="attorney.value">
        {{ attorney.label }}
      </option>
    </select>
  </div>
  <div class="form-group">
    <label>Web Site</label>
    <input type="text" class="form-control form-control-sm" name="url" [(ngModel)]="contact.url" />
  </div>
  <div class="form-group">
    <label>Share Password</label>
    <input type="text" class="form-control form-control-sm" name="share_password" [(ngModel)]="contact.share_password" />
  </div>
  <div class="form-group">
    <div class="custom-control custom-checkbox" (click)="contact.referral_source = !contact.referral_source">
      <input type="checkbox" class="custom-control-input" [checked]="contact.referral_source" />
      <label class="custom-control-label">Is a Referral Source</label>
    </div>
    <div class="custom-control custom-checkbox" (click)="contact.referral_destination = !contact.referral_destination">
      <input type="checkbox" class="custom-control-input" [checked]="contact.referral_destination" />
      <label class="custom-control-label">Is a Referral Destination</label>
    </div>
    <div class="custom-control custom-checkbox" (click)="contact.is_on_mailing_list = !contact.is_on_mailing_list">
      <input type="checkbox" class="custom-control-input" [checked]="contact.is_on_mailing_list" />
      <label class="custom-control-label">On Mailing List</label>
    </div>
    <div class="custom-control custom-checkbox" (click)="contact.is_private = !contact.is_private">
      <input type="checkbox" class="custom-control-input" [checked]="contact.is_private" />
      <label class="custom-control-label">Is Private</label>
    </div>
    <div class="custom-control custom-checkbox" (click)="contact.requires_1099 = !contact.requires_1099">
      <input type="checkbox" class="custom-control-input" [checked]="contact.requires_1099" />
      <label class="custom-control-label">Requires 1099</label>
    </div>
  </div>
  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control form-control-sm" name="notes" [(ngModel)]="contact.notes"></textarea>
  </div>
  <div class="form-row">
    <div [ngClass]="{ col: contactId, 'col-6': !contactId }">
      <button type="button" class="btn btn-primary btn-sm btn-block" [disabled]="formSubmitting" (click)="save(currentForm.form.valid)">Save</button>
    </div>
    <div class="col-6" *ngIf="!contactId">
      <button type="button" class="btn btn-outline-secondary btn-block btn-sm" [disabled]="formSubmitting" (click)="back()">Cancel</button>
    </div>
  </div>
</form>
